import { Component, ChangeDetectionStrategy } from '@angular/core';
@Component({
  selector: 'cm-terms-and-conditions',
  templateUrl: './term-and-conditions.component.html',
  styleUrls: ['./term-and-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TermsAndConditionsComponent {
  constructor() {}
}
